var _ = Object.defineProperty, j = Object.defineProperties;
var D = Object.getOwnPropertyDescriptors;
var l = Object.getOwnPropertySymbols;
var f = Object.prototype.hasOwnProperty, y = Object.prototype.propertyIsEnumerable;
var d = (r, s, o) => s in r ? _(r, s, { enumerable: !0, configurable: !0, writable: !0, value: o }) : r[s] = o, i = (r, s) => {
  for (var o in s || (s = {}))
    f.call(s, o) && d(r, o, s[o]);
  if (l)
    for (var o of l(s))
      y.call(s, o) && d(r, o, s[o]);
  return r;
}, v = (r, s) => j(r, D(s));
var n = (r, s) => {
  var o = {};
  for (var e in r)
    f.call(r, e) && s.indexOf(e) < 0 && (o[e] = r[e]);
  if (r != null && l)
    for (var e of l(r))
      s.indexOf(e) < 0 && y.call(r, e) && (o[e] = r[e]);
  return o;
};
import { jsx as F } from "react/jsx-runtime";
import { r as O } from "./rem-CMQJ_ZTp.js";
import "react";
import { g as V } from "./OptionalPortal-sP4Hf4UO.js";
import { e as Z } from "./get-size-Bc1Pz5yf.js";
import { c as $ } from "./create-vars-resolver-Bzbn9G-G.js";
import { u as q, B as w, r as A } from "./factory-ueRxoNOV.js";
import { u as C } from "./use-styles-DToiHEa6.js";
import { p as E } from "./polymorphic-factory-DufevJAl.js";
var c = { root: "m_9814e45f" };
const G = {
  zIndex: V("modal")
}, H = $(
  (r, { gradient: s, color: o, backgroundOpacity: e, blur: a, radius: m, zIndex: t }) => ({
    root: {
      "--overlay-bg": s || (o !== void 0 || e !== void 0) && A(o || "#000", e != null ? e : 0.6) || void 0,
      "--overlay-filter": a ? `blur(${O(a)})` : void 0,
      "--overlay-radius": m === void 0 ? void 0 : Z(m),
      "--overlay-z-index": t == null ? void 0 : t.toString()
    }
  })
), u = E((r, s) => {
  const o = q("Overlay", G, r), p = o, {
    classNames: e,
    className: a,
    style: m,
    styles: t,
    unstyled: g,
    vars: x,
    fixed: h,
    center: N,
    children: R,
    radius: J,
    zIndex: K,
    gradient: L,
    blur: M,
    color: Q,
    backgroundOpacity: T,
    mod: S
  } = p, B = n(p, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "fixed",
    "center",
    "children",
    "radius",
    "zIndex",
    "gradient",
    "blur",
    "color",
    "backgroundOpacity",
    "mod"
  ]), P = C({
    name: "Overlay",
    props: o,
    classes: c,
    className: a,
    style: m,
    classNames: e,
    styles: t,
    unstyled: g,
    vars: x,
    varsResolver: H
  });
  return /* @__PURE__ */ F(w, v(i(v(i({ ref: s }, P("root")), { mod: [{ center: N, fixed: h }, S] }), B), { children: R }));
});
u.classes = c;
u.displayName = "@mantine/core/Overlay";
export {
  u as O
};
